// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BMI-module__font-s-10___ug_d9 {
  font-size: 10px !important;
}

.BMI-module__font-s-12___fega2 {
  font-size: 12px !important;
}

.BMI-module__font-s-13___qQCMM {
  font-size: 13px !important;
}

.BMI-module__font-s-14___BFg3P {
  font-size: 14px !important;
}

.BMI-module__font-s-15___TTGAV {
  font-size: 15px !important;
}

.BMI-module__font-s-16___UvUtC {
  font-size: 16px !important;
}

.BMI-module__font-s-18___jT0Vy {
  font-size: 18px !important;
}

.BMI-module__font-s-20___gwwUz {
  font-size: 20px !important;
}

.BMI-module__font-s-22____Ru4I {
  font-size: 22px !important;
}

.BMI-module__font-s-28___p8APK {
  font-size: 28px !important;
}

.BMI-module__font-w-400___lyi4c {
  font-weight: 400 !important;
}

.BMI-module__font-w-500___jwBVk {
  font-weight: 500 !important;
}

.BMI-module__font-w-600___MSPq3 {
  font-weight: 600 !important;
}

.BMI-module__font-w-700___PuXVl {
  font-weight: 700 !important;
}

.BMI-module__p-5___zavjg {
  padding: 5px !important;
}

.BMI-module__p-12___LVUxr {
  padding: 12px !important;
}

.BMI-module__p-16___DrZc3 {
  padding: 16px !important;
}

.BMI-module__p-30___MHdsW {
  padding: 30px !important;
}

.BMI-module__p-b-0___mltDw {
  padding-bottom: 0 !important;
}

.BMI-module__p-b-5___IF8IM {
  padding-bottom: 5px !important;
}

.BMI-module__p-b-10___vuma3 {
  padding-bottom: 10px !important;
}

.BMI-module__p-b-12___GUFiU {
  padding-bottom: 12px !important;
}

.BMI-module__p-b-16___BUUqX {
  padding-bottom: 16px !important;
}

.BMI-module__p-b-18___yoNqm {
  padding-bottom: 18px !important;
}

.BMI-module__p-b-20___VjRDC {
  padding-bottom: 20px !important;
}

.BMI-module__p-b-25___YyHdL {
  padding-bottom: 25px !important;
}

.BMI-module__p-b-30___jSNV_ {
  padding-bottom: 30px !important;
}

.BMI-module__p-b-50___yaTd7 {
  padding-bottom: 50px !important;
}

.BMI-module__p-t-0___pTLGt {
  padding-top: 0 !important;
}

.BMI-module__p-t-12___OJKjk {
  padding-top: 12px !important;
}

.BMI-module__p-t-16___LcNJh {
  padding-top: 16px !important;
}

.BMI-module__p-t-18___DHJc2 {
  padding-top: 18px !important;
}

.BMI-module__p-t-20____74bc {
  padding-top: 20px !important;
}

.BMI-module__p-t-30___B8Yzj {
  padding-top: 30px !important;
}

.BMI-module__p-t-40___lgUOV {
  padding-top: 40px !important;
}

.BMI-module__p-t-50____0fRy {
  padding-top: 50px !important;
}

.BMI-module__p-l-20___gNDlh {
  padding-left: 20px !important;
}

.BMI-module__p-l-30___h7C6T {
  padding-left: 30px !important;
}

.BMI-module__p-l-40___HivGq {
  padding-left: 40px !important;
}

.BMI-module__p-r-16___j0Pv7 {
  padding-right: 16px !important;
}

.BMI-module__p-r-20___VqA_j {
  padding-right: 20px !important;
}

.BMI-module__p-r-30___EE_KQ {
  padding-right: 30px !important;
}

.BMI-module__p-r-50___WG2y8 {
  padding-right: 50px !important;
}

.BMI-module__p-r-60___KtMPf {
  padding-right: 60px !important;
}

.BMI-module__m-b-1___U_Y6Y {
  margin-bottom: 1px !important;
}

.BMI-module__m-b-2___pKq4b {
  margin-bottom: 2px !important;
}

.BMI-module__m-b-6___sSy6K {
  margin-bottom: 6px !important;
}

.BMI-module__m-b-8___rmxSQ {
  margin-bottom: 8px !important;
}

.BMI-module__m-b-10___BmXQt {
  margin-bottom: 10px !important;
}

.BMI-module__m-b-14___WI7aU {
  margin-bottom: 14px !important;
}

.BMI-module__m-b-16___OLN_E {
  margin-bottom: 16px !important;
}

.BMI-module__m-b-20___h5Ote {
  margin-bottom: 20px !important;
}

.BMI-module__m-b-22___Vb1cL {
  margin-bottom: 22px !important;
}

.BMI-module__m-b-24___gTAlT {
  margin-bottom: 24px !important;
}

.BMI-module__m-b-30___KbKyY {
  margin-bottom: 30px !important;
}

.BMI-module__m-b-32___tJuDA {
  margin-bottom: 32px !important;
}

.BMI-module__m-b-40___Hzt5n {
  margin-bottom: 40px !important;
}

.BMI-module__m-t-2___evXWD {
  margin-top: 2px !important;
}

.BMI-module__m-t-3___AZTgo {
  margin-top: 3px !important;
}

.BMI-module__m-t-4___WeyOS {
  margin-top: 4px !important;
}

.BMI-module__m-t-5___PXe8S {
  margin-top: 5px !important;
}

.BMI-module__m-t-8___eWEsx {
  margin-top: 8px !important;
}

.BMI-module__m-t-10___ia8Gy {
  margin-top: 10px !important;
}

.BMI-module__m-t-15___Efvyo {
  margin-top: 15px !important;
}

.BMI-module__m-t-16___Gny8e {
  margin-top: 16px !important;
}

.BMI-module__m-t-20___AXSqP {
  margin-top: 20px !important;
}

.BMI-module__m-t-22___jeukY {
  margin-top: 22px !important;
}

.BMI-module__m-t-30___gSi7l {
  margin-top: 30px !important;
}

.BMI-module__m-t-32___fFzoe {
  margin-top: 32px !important;
}

.BMI-module__m-l-auto___EiQYt {
  margin-left: auto !important;
}

.BMI-module__m-l-4___nMSYQ {
  margin-left: 4px !important;
}

.BMI-module__m-l-5___P4Rb0 {
  margin-left: 5px !important;
}

.BMI-module__m-l-6___Rrw_Z {
  margin-left: 6px !important;
}

.BMI-module__m-l-8___da5FU {
  margin-left: 8px !important;
}

.BMI-module__m-l-10___ZctOd {
  margin-left: 10px !important;
}

.BMI-module__m-l-16___OH3Tt {
  margin-left: 16px !important;
}

.BMI-module__m-l-20___YerXl {
  margin-left: 20px !important;
}

.BMI-module__m-l-24___xbPHt {
  margin-left: 24px !important;
}

.BMI-module__m-l-30___PRdXf {
  margin-left: 30px !important;
}

.BMI-module__m-l-35___akD5e {
  margin-left: 35px !important;
}

.BMI-module__m-l-40___Dq9tm {
  margin-left: 40px !important;
}

.BMI-module__m-r-8___m6Q6p {
  margin-right: 8px !important;
}

.BMI-module__m-r-10___TLQ7k {
  margin-right: 10px !important;
}

.BMI-module__m-r-16___hLbyh {
  margin-right: 16px !important;
}

.BMI-module__m-r-20___qwJ1X {
  margin-right: 20px !important;
}

.BMI-module__m-r-24___ob3di {
  margin-right: 24px !important;
}

.BMI-module__m-r-30___CNDOh {
  margin-right: 30px !important;
}

.BMI-module__m-r-40___wF1f2 {
  margin-right: 40px !important;
}

.BMI-module__border-r-3___JQDQh {
  border-radius: 3px !important;
}

.BMI-module__border-r-4___KhzW5 {
  border-radius: 4px !important;
}

.BMI-module__border-r-6___r1e4L {
  border-radius: 6px !important;
}

.BMI-module__border-r-10___gFf2i {
  border-radius: 10px !important;
}

.BMI-module__border-r-12___ed5ZX {
  border-radius: 12px !important;
}

.BMI-module__border-r-16___fviiY {
  border-radius: 16px !important;
}

.BMI-module__border-r-50___MahQi {
  border-radius: 50% !important;
}

.BMI-module__primary-border___iOZQP {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BMI-module__primary-border-b___c4V3G {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BMI-module__primary-border-t___PjNNG {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BMI-module__primary-border-l___PU4Ij {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BMI-module__primary-border-r____j0uD {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BMI-module__secondary-border___YzdJH {
  border: 1px solid #637768;
}

.BMI-module__secondary-border-b___dnqlA {
  border-bottom: 1px solid #637768;
}

.BMI-module__secondary-border-t___D8rAx {
  border-top: 1px solid #637768;
}

.BMI-module__secondary-border-l___o3OWa {
  border-left: 1px solid #637768;
}

.BMI-module__secondary-border-r___D1WGQ {
  border-right: 1px solid #637768;
}

.BMI-module__gap-0____aovv {
  gap: 0 !important;
}

.BMI-module__gap-2___MPvwN {
  gap: 2px !important;
}

.BMI-module__gap-4___x_XOe {
  gap: 4px !important;
}

.BMI-module__gap-5___MrhLL {
  gap: 5px !important;
}

.BMI-module__gap-6___I0oJx {
  gap: 6px !important;
}

.BMI-module__gap-8___ZTXwA {
  gap: 8px !important;
}

.BMI-module__gap-10___NIzVQ {
  gap: 10px !important;
}

.BMI-module__gap-12___pKo5D {
  gap: 12px !important;
}

.BMI-module__gap-14___CgX0b {
  gap: 14px !important;
}

.BMI-module__gap-16___F2m6s {
  gap: 16px !important;
}

.BMI-module__gap-18___e104C {
  gap: 18px !important;
}

.BMI-module__gap-20___V1MN5 {
  gap: 20px !important;
}

.BMI-module__gap-24___WjZK8 {
  gap: 24px !important;
}

.BMI-module__gap-26___P7xnt {
  gap: 26px !important;
}

.BMI-module__gap-30___foEIG {
  gap: 30px !important;
}

.BMI-module__gap-32___jVwqJ {
  gap: 32px !important;
}

.BMI-module__gap-40___yyyFL {
  gap: 40px !important;
}

.BMI-module__gap-50___NNAe0 {
  gap: 50px !important;
}

.BMI-module__flex-1___gcaoh {
  flex: 1;
}

.BMI-module__flex-none___cdvoJ {
  flex: none !important;
}

.BMI-module__flex-column___f8yrv {
  display: flex;
  flex-direction: column !important;
}

.BMI-module__flex-row___sawUR {
  display: flex;
  flex-direction: row !important;
}

.BMI-module__vertically-centered___cdlJQ {
  display: flex;
  align-items: center !important;
}

.BMI-module__horizontally-centered___yVFh5 {
  display: flex;
  justify-content: center !important;
}

.BMI-module__horizontally-end___q92lX {
  display: flex;
  justify-content: end !important;
}

.BMI-module__vertically-start___mtr6I {
  display: flex;
  align-items: start !important;
}

.BMI-module__space-between___DUQbE {
  display: flex;
  justify-content: space-between !important;
}

.BMI-module__flex-wrap___esXDB {
  flex-wrap: wrap !important;
}

.BMI-module__height-100___mZy06 {
  height: 100%;
}

.BMI-module__width-50___bazog {
  width: 50% !important;
}

.BMI-module__width-100___ABL9E {
  width: 100%;
}

.BMI-module__cursor-pointer___A8y1W {
  cursor: pointer;
}

.BMI-module__cursor-not-allowed___tkXI3 {
  cursor: not-allowed !important;
}

.BMI-module__absolute-centered___RkiEe {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BMI-module__absolute___Qs9yH {
  position: absolute;
}

.BMI-module__relative___Uvjm2 {
  position: relative;
}

.BMI-module__fixed___NTo9D {
  position: fixed;
}

.BMI-module__visible___JwsqH {
  opacity: 1;
}

.BMI-module__invisible___l5ryN {
  opacity: 0;
}

.BMI-module__col-90___wnocr {
  width: 90% !important;
}

.BMI-module__col-auto___TOrAH {
  width: auto !important;
}

.BMI-module__medical-tabs___kz7v4 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BMI-module__medical-table-new___X4U6Z {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BMI-module__medical-table-new___X4U6Z:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BMI-module__medical-table-new___X4U6Z::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BMI-module__medical-table-new___X4U6Z::-webkit-scrollbar-track {
  display: none;
}
.BMI-module__medical-table-new___X4U6Z.BMI-module__no-pagination___dU_v5 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BMI-module__medical-table-new___X4U6Z.BMI-module__no-pagination___dU_v5:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BMI-module__medical-table-new___X4U6Z.BMI-module__no-pagination___dU_v5::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BMI-module__medical-table-new___X4U6Z.BMI-module__no-pagination___dU_v5::-webkit-scrollbar-track {
  display: none;
}

.BMI-module__medical-table-empty___FbUPK {
  padding: 14px 40px !important;
}

.BMI-module__icon-btn___ng9f2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BMI-module__search-icon___bln24 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BMI-module__disable-select___gDJ4K {
  user-select: none;
}

.BMI-module__break-word___ME78_ {
  word-break: break-word;
}

.BMI-module__popup-clear-btn___Pmy69 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BMI-module__scroll-m-b-20___zN1KJ {
  scroll-margin-bottom: 20px;
}

.BMI-module__text___NfkAH {
  display: flex;
  min-height: 35px;
  width: 150px;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px 0 10px;
  line-height: 150%;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Vitals/items/BMI/BMI.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.text {\n  display: flex;\n  min-height: 35px;\n  width: 150px;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 16px 0 10px;\n  line-height: 150%;\n  align-items: center;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BMI-module__font-s-10___ug_d9`,
	"fontS12": `BMI-module__font-s-12___fega2`,
	"fontS13": `BMI-module__font-s-13___qQCMM`,
	"fontS14": `BMI-module__font-s-14___BFg3P`,
	"fontS15": `BMI-module__font-s-15___TTGAV`,
	"fontS16": `BMI-module__font-s-16___UvUtC`,
	"fontS18": `BMI-module__font-s-18___jT0Vy`,
	"fontS20": `BMI-module__font-s-20___gwwUz`,
	"fontS22": `BMI-module__font-s-22____Ru4I`,
	"fontS28": `BMI-module__font-s-28___p8APK`,
	"fontW400": `BMI-module__font-w-400___lyi4c`,
	"fontW500": `BMI-module__font-w-500___jwBVk`,
	"fontW600": `BMI-module__font-w-600___MSPq3`,
	"fontW700": `BMI-module__font-w-700___PuXVl`,
	"p5": `BMI-module__p-5___zavjg`,
	"p12": `BMI-module__p-12___LVUxr`,
	"p16": `BMI-module__p-16___DrZc3`,
	"p30": `BMI-module__p-30___MHdsW`,
	"pB0": `BMI-module__p-b-0___mltDw`,
	"pB5": `BMI-module__p-b-5___IF8IM`,
	"pB10": `BMI-module__p-b-10___vuma3`,
	"pB12": `BMI-module__p-b-12___GUFiU`,
	"pB16": `BMI-module__p-b-16___BUUqX`,
	"pB18": `BMI-module__p-b-18___yoNqm`,
	"pB20": `BMI-module__p-b-20___VjRDC`,
	"pB25": `BMI-module__p-b-25___YyHdL`,
	"pB30": `BMI-module__p-b-30___jSNV_`,
	"pB50": `BMI-module__p-b-50___yaTd7`,
	"pT0": `BMI-module__p-t-0___pTLGt`,
	"pT12": `BMI-module__p-t-12___OJKjk`,
	"pT16": `BMI-module__p-t-16___LcNJh`,
	"pT18": `BMI-module__p-t-18___DHJc2`,
	"pT20": `BMI-module__p-t-20____74bc`,
	"pT30": `BMI-module__p-t-30___B8Yzj`,
	"pT40": `BMI-module__p-t-40___lgUOV`,
	"pT50": `BMI-module__p-t-50____0fRy`,
	"pL20": `BMI-module__p-l-20___gNDlh`,
	"pL30": `BMI-module__p-l-30___h7C6T`,
	"pL40": `BMI-module__p-l-40___HivGq`,
	"pR16": `BMI-module__p-r-16___j0Pv7`,
	"pR20": `BMI-module__p-r-20___VqA_j`,
	"pR30": `BMI-module__p-r-30___EE_KQ`,
	"pR50": `BMI-module__p-r-50___WG2y8`,
	"pR60": `BMI-module__p-r-60___KtMPf`,
	"mB1": `BMI-module__m-b-1___U_Y6Y`,
	"mB2": `BMI-module__m-b-2___pKq4b`,
	"mB6": `BMI-module__m-b-6___sSy6K`,
	"mB8": `BMI-module__m-b-8___rmxSQ`,
	"mB10": `BMI-module__m-b-10___BmXQt`,
	"mB14": `BMI-module__m-b-14___WI7aU`,
	"mB16": `BMI-module__m-b-16___OLN_E`,
	"mB20": `BMI-module__m-b-20___h5Ote`,
	"mB22": `BMI-module__m-b-22___Vb1cL`,
	"mB24": `BMI-module__m-b-24___gTAlT`,
	"mB30": `BMI-module__m-b-30___KbKyY`,
	"mB32": `BMI-module__m-b-32___tJuDA`,
	"mB40": `BMI-module__m-b-40___Hzt5n`,
	"mT2": `BMI-module__m-t-2___evXWD`,
	"mT3": `BMI-module__m-t-3___AZTgo`,
	"mT4": `BMI-module__m-t-4___WeyOS`,
	"mT5": `BMI-module__m-t-5___PXe8S`,
	"mT8": `BMI-module__m-t-8___eWEsx`,
	"mT10": `BMI-module__m-t-10___ia8Gy`,
	"mT15": `BMI-module__m-t-15___Efvyo`,
	"mT16": `BMI-module__m-t-16___Gny8e`,
	"mT20": `BMI-module__m-t-20___AXSqP`,
	"mT22": `BMI-module__m-t-22___jeukY`,
	"mT30": `BMI-module__m-t-30___gSi7l`,
	"mT32": `BMI-module__m-t-32___fFzoe`,
	"mLAuto": `BMI-module__m-l-auto___EiQYt`,
	"mL4": `BMI-module__m-l-4___nMSYQ`,
	"mL5": `BMI-module__m-l-5___P4Rb0`,
	"mL6": `BMI-module__m-l-6___Rrw_Z`,
	"mL8": `BMI-module__m-l-8___da5FU`,
	"mL10": `BMI-module__m-l-10___ZctOd`,
	"mL16": `BMI-module__m-l-16___OH3Tt`,
	"mL20": `BMI-module__m-l-20___YerXl`,
	"mL24": `BMI-module__m-l-24___xbPHt`,
	"mL30": `BMI-module__m-l-30___PRdXf`,
	"mL35": `BMI-module__m-l-35___akD5e`,
	"mL40": `BMI-module__m-l-40___Dq9tm`,
	"mR8": `BMI-module__m-r-8___m6Q6p`,
	"mR10": `BMI-module__m-r-10___TLQ7k`,
	"mR16": `BMI-module__m-r-16___hLbyh`,
	"mR20": `BMI-module__m-r-20___qwJ1X`,
	"mR24": `BMI-module__m-r-24___ob3di`,
	"mR30": `BMI-module__m-r-30___CNDOh`,
	"mR40": `BMI-module__m-r-40___wF1f2`,
	"borderR3": `BMI-module__border-r-3___JQDQh`,
	"borderR4": `BMI-module__border-r-4___KhzW5`,
	"borderR6": `BMI-module__border-r-6___r1e4L`,
	"borderR10": `BMI-module__border-r-10___gFf2i`,
	"borderR12": `BMI-module__border-r-12___ed5ZX`,
	"borderR16": `BMI-module__border-r-16___fviiY`,
	"borderR50": `BMI-module__border-r-50___MahQi`,
	"primaryBorder": `BMI-module__primary-border___iOZQP`,
	"primaryBorderB": `BMI-module__primary-border-b___c4V3G`,
	"primaryBorderT": `BMI-module__primary-border-t___PjNNG`,
	"primaryBorderL": `BMI-module__primary-border-l___PU4Ij`,
	"primaryBorderR": `BMI-module__primary-border-r____j0uD`,
	"secondaryBorder": `BMI-module__secondary-border___YzdJH`,
	"secondaryBorderB": `BMI-module__secondary-border-b___dnqlA`,
	"secondaryBorderT": `BMI-module__secondary-border-t___D8rAx`,
	"secondaryBorderL": `BMI-module__secondary-border-l___o3OWa`,
	"secondaryBorderR": `BMI-module__secondary-border-r___D1WGQ`,
	"gap0": `BMI-module__gap-0____aovv`,
	"gap2": `BMI-module__gap-2___MPvwN`,
	"gap4": `BMI-module__gap-4___x_XOe`,
	"gap5": `BMI-module__gap-5___MrhLL`,
	"gap6": `BMI-module__gap-6___I0oJx`,
	"gap8": `BMI-module__gap-8___ZTXwA`,
	"gap10": `BMI-module__gap-10___NIzVQ`,
	"gap12": `BMI-module__gap-12___pKo5D`,
	"gap14": `BMI-module__gap-14___CgX0b`,
	"gap16": `BMI-module__gap-16___F2m6s`,
	"gap18": `BMI-module__gap-18___e104C`,
	"gap20": `BMI-module__gap-20___V1MN5`,
	"gap24": `BMI-module__gap-24___WjZK8`,
	"gap26": `BMI-module__gap-26___P7xnt`,
	"gap30": `BMI-module__gap-30___foEIG`,
	"gap32": `BMI-module__gap-32___jVwqJ`,
	"gap40": `BMI-module__gap-40___yyyFL`,
	"gap50": `BMI-module__gap-50___NNAe0`,
	"flex1": `BMI-module__flex-1___gcaoh`,
	"flexNone": `BMI-module__flex-none___cdvoJ`,
	"flexColumn": `BMI-module__flex-column___f8yrv`,
	"flexRow": `BMI-module__flex-row___sawUR`,
	"verticallyCentered": `BMI-module__vertically-centered___cdlJQ`,
	"horizontallyCentered": `BMI-module__horizontally-centered___yVFh5`,
	"horizontallyEnd": `BMI-module__horizontally-end___q92lX`,
	"verticallyStart": `BMI-module__vertically-start___mtr6I`,
	"spaceBetween": `BMI-module__space-between___DUQbE`,
	"flexWrap": `BMI-module__flex-wrap___esXDB`,
	"height100": `BMI-module__height-100___mZy06`,
	"width50": `BMI-module__width-50___bazog`,
	"width100": `BMI-module__width-100___ABL9E`,
	"cursorPointer": `BMI-module__cursor-pointer___A8y1W`,
	"cursorNotAllowed": `BMI-module__cursor-not-allowed___tkXI3`,
	"absoluteCentered": `BMI-module__absolute-centered___RkiEe`,
	"absolute": `BMI-module__absolute___Qs9yH`,
	"relative": `BMI-module__relative___Uvjm2`,
	"fixed": `BMI-module__fixed___NTo9D`,
	"visible": `BMI-module__visible___JwsqH`,
	"invisible": `BMI-module__invisible___l5ryN`,
	"col90": `BMI-module__col-90___wnocr`,
	"colAuto": `BMI-module__col-auto___TOrAH`,
	"medicalTabs": `BMI-module__medical-tabs___kz7v4`,
	"medicalTableNew": `BMI-module__medical-table-new___X4U6Z`,
	"noPagination": `BMI-module__no-pagination___dU_v5`,
	"medicalTableEmpty": `BMI-module__medical-table-empty___FbUPK`,
	"iconBtn": `BMI-module__icon-btn___ng9f2`,
	"searchIcon": `BMI-module__search-icon___bln24`,
	"disableSelect": `BMI-module__disable-select___gDJ4K`,
	"breakWord": `BMI-module__break-word___ME78_`,
	"popupClearBtn": `BMI-module__popup-clear-btn___Pmy69`,
	"scrollMB20": `BMI-module__scroll-m-b-20___zN1KJ`,
	"text": `BMI-module__text___NfkAH`
};
module.exports = ___CSS_LOADER_EXPORT___;
